var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 18",
    fill: "#020710",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.837 7.843a3.516 3.516 0 1 0-2.704-6.491 3.516 3.516 0 0 0 2.704 6.491ZM6.477 9.27C2.915 9.27 0 12.184 0 15.747c0 .925.74 1.711 1.712 1.711h9.576c.925 0 1.712-.74 1.712-1.711-.046-3.563-2.915-6.477-6.523-6.477Z"
  })));
};

export default SvgPerson;